import Vue from 'vue'

const state = {
  newGroup: {
    participants: [],
    PhotoURL: '',
    groupName: ''
  },

  addToGroup: {
    oldParticipants: [],
    participants: [],
    PhotoURL: '',
    groupName: ''
  },

  groups: []
}

const getters = {
  filteredGroups: (state, getters, rootState) => {
    var groups = state.groups
    groups.sort(function (a, b) {
      if (a.GroupName < b.GroupName) return -1
      if (a.GroupName > b.GroupName) return 1
      return 0
    })

    let filtered = groups.filter(g => g.ConversationID !== rootState.conversation.messageToForward.To &&
      !(g.Deleteds && g.Deleteds.length > 0 && g.Deleteds.includes(rootState.session.user.UserID)))

    return filtered
  }
}

const mutations = {
  appendNewGroupParticipant (state, data) {
    state.newGroup.participants.push(data)
  },

  resetNewGroupParticipants (state) {
    state.newGroup.participants = []
  },

  setNewGroupParticipants (state, data) {
    state.newGroup.participants = data
  },

  appendAdditionalGroupParticipant (state, data) {
    state.addToGroup.participants.push(data)
  },

  resetAdditionalGroupParticipants (state) {
    state.addToGroup.participants = []
  },

  setAdditionalGroupParticipants (state, data) {
    state.addToGroup.participants = data
  },

  setOldGroupParticipants (state, data) {
    state.addToGroup.oldParticipants = data
  },

  setGroups (state, data) {
    for (let conv of data) {
      let newMsg = JSON.parse(
        JSON.stringify(data.rootState.message.newMessageModel)
      )
      Vue.set(conv, 'newMessage', newMsg)
      let uploaders = JSON.parse(
        JSON.stringify(data.rootState.message.uploadersModel)
      )
      Vue.set(conv, 'uploaders', uploaders)

      let preview = JSON.parse(
        JSON.stringify(data.rootState.message.previewModel)
      )
      Vue.set(conv, 'preview', preview)
    }
    for (const iterator of data.rootState.conversation.clearedConversations) {
      if (iterator.isRemove === true) {
        let item = data.find(x => x.GroupID === iterator.UniqueID && new Date(x.CreateDate).getTime() <= new Date(iterator.ClearDate).getTime())
        let i = data.indexOf(item)
        if (i !== -1) {
          let filteredMessages = data.rootState.message.messages.filter(x => x.To === iterator.UniqueID)
          if (filteredMessages.length === 0) {
            data.splice(i, 1)
          }
        }
      } else {
        let item2 = data.find(x => x.GroupID === iterator.UniqueID && new Date(x.CreateDate).getTime() <= new Date(iterator.ClearDate).getTime())
        if (item2) {
          item2.LastMessage = {}
        }
      }
    }
    state.groups = data
    let activeConversationID = data.rootState.conversation.activeConversation && data.rootState.conversation.activeConversation.ConversationID
    if (activeConversationID) {
      let activeGroup = state.groups.find(x => x.GroupID === activeConversationID)
      if (activeGroup) {
        data.rootState.conversation.activeConversation = activeGroup
      }
    }
  },

  appendGroup (state, data) {
    let newMsg = JSON.parse(
      JSON.stringify(data.rootState.message.newMessageModel)
    )
    Vue.set(data, 'newMessage', newMsg)
    let uploaders = JSON.parse(
      JSON.stringify(data.rootState.message.uploadersModel)
    )
    Vue.set(data, 'uploaders', uploaders)

    let preview = JSON.parse(
      JSON.stringify(data.rootState.message.previewModel)
    )
    Vue.set(data, 'preview', preview)

    state.groups.push(data)
  },

  updateGroup (state, data) {
    let updatedGroupData = data.Data
    let groupToEdit = state.groups.find(g => g.GroupID === updatedGroupData.GroupID)

    groupToEdit.GroupName = updatedGroupData.GroupName
    groupToEdit.GroupDescription = updatedGroupData.GroupDescription
    groupToEdit.MessageAuth = updatedGroupData.MessageAuth
    groupToEdit.Owner = updatedGroupData.Owner
    groupToEdit.PhotoURL = updatedGroupData.PhotoURL
    groupToEdit.UpdateDate = updatedGroupData.UpdateDate
    groupToEdit.isActive = updatedGroupData.isActive
    groupToEdit.isLDAPGroup = updatedGroupData.isLDAPGroup
  },

  addParticipant (state, data) {
    let groupToEdit = state.groups.find(g => g.GroupID === data.GroupID)
    let participants = data.Participants

    participants.forEach(p => {
      groupToEdit.Participants.push(p)

      if (groupToEdit.Deleteds) {
        let index = groupToEdit.Deleteds.indexOf(p)
        if (index !== -1) {
          groupToEdit.Deleteds.splice(index, 1)
        }
      }
    })
  },

  removeParticipant (state, data) {
    let groupToEdit = state.groups.find(g => g.GroupID === data.GroupID)
    let participantsToRemove = data.Participants

    participantsToRemove.forEach(p => {
      let index = groupToEdit.Participants.indexOf(p)
      if (index !== -1) {
        groupToEdit.Participants.splice(index, 1)
      } else if (groupToEdit.Admins) {
        let indexA = groupToEdit.Admins.indexOf(p)
        if (indexA !== -1) {
          groupToEdit.Admins.splice(indexA, 1)
        }
      }

      if (groupToEdit.Deleted) {
        groupToEdit.Deleteds.push(p)
      } else {
        groupToEdit.Deleteds = [p]
      }
    })
  },

  makeAdmin (state, data) {
    let groupToEdit = state.groups.find(g => g.GroupID === data.GroupID)
    if (groupToEdit.Admins) {
      groupToEdit.Admins.push(data.UserID)
    } else {
      groupToEdit.Admins = [data.UserID]
    }

    let index = groupToEdit.Participants.indexOf(data.UserID)
    if (index !== -1) {
      groupToEdit.Participants.splice(index, 1)
    }
  },

  removeAdmin (state, data) {
    let groupToEdit = state.groups.find(g => g.GroupID === data.GroupID)
    if (groupToEdit.Admins) {
      let index = groupToEdit.Admins.indexOf(data.UserID)
      if (index !== -1) {
        groupToEdit.Admins.splice(index, 1)
      }
    } else {
      groupToEdit.Admins = []
    }

    groupToEdit.Participants.push(data.UserID)
  },

  makeOwner (state, data) {
    let groupToEdit = state.groups.find(g => g.GroupID === data.GroupID)
    let newOwnerID = data.UserID

    let index = groupToEdit.Participants.indexOf(newOwnerID)
    if (index !== -1) {
      groupToEdit.Participants.splice(index, 1)
    } else if (groupToEdit.Admins) {
      let indexA = groupToEdit.Admins.indexOf(newOwnerID)
      if (indexA !== -1) {
        groupToEdit.Admins.splice(indexA, 1)
      }
    }
    groupToEdit.Owner = newOwnerID
  }
}

const actions = {
  setGroups (context, data) {
    data.rootState = context.rootState
    context.commit('setGroups', data)
  },
  appendGroup (context, data) {
    data.rootState = context.rootState
    context.commit('appendGroup', data)
  },
  addParticipant (context, data) {
    data.rootState = context.rootState
    context.commit('addParticipant', data)
  },
  removeParticipant (context, data) {
    data.rootState = context.rootState
    context.commit('removeParticipant', data)
  },
  makeAdmin (context, data) {
    data.rootState = context.rootState
    context.commit('makeAdmin', data)
  },
  removeAdmin (context, data) {
    data.rootState = context.rootState
    context.commit('removeAdmin', data)
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
